export default {
  loginClass: 'with-panel with-panel-left build',
  unloginedClass: 'with-panel build'
};
